import React, {createContext} from "react";
import localForage from "localforage";
import {useLocalStore} from "mobx-react-lite";
import {toJS} from 'mobx';

export const AppStoreContext = createContext();

export const AppStoreProvider = ({children}) => {
    const store = useLocalStore(() => ({

        // Observable data
        sessionData: undefined,
        sessionStatus: SESSION_STATUS.LOADING,
        initialDataStatus: SESSION_STATUS.LOADING,
        selectedBot: undefined,
        adminDetails: undefined,
        isMasterAdmin: false,
        isOwner: false,
        isActiveForLiveChat: undefined,
        allAdmins: [],
        leadBots: [],

        // Actions & Computed functions
        setSessionStatus(status) {
            this.sessionStatus = status;
        },
        get getSessionStatus() {
            return toJS(this.sessionStatus);
        },
        setSessionData(data) {
            this.sessionData = data;
        },
        get getSessionData() {
            return toJS(this.sessionData);
        },
        setInitialDataStatus(status) {
            this.initialDataStatus = status
        },
        selectBot(selectedBot) {
            this.selectedBot = selectedBot;
            localForage.setItem('selectedBot', selectedBot);
            // this.refreshPendingActionsCount();
        }, get getSelectedBot() {
            return toJS(this.selectedBot);
        },
        get getInitialDataStatus() {
            return toJS(this.initialDataStatus);
        }, setAdminDetails(adminDetails) {
            this.adminDetails = adminDetails;
        }, get getAdminDetails() {
            return toJS(this.adminDetails);
        },
        setIsMasterAdmin(isMasterAdmin) {
            this.isMasterAdmin = isMasterAdmin;
        }, get getIsMasterAdmin() {
            return toJS(this.isMasterAdmin);
        }, setIsOwner(isOwner) {
            this.isOwner = isOwner;
        },
        get getIsOwner() {
            return toJS(this.isOwner);
        }, setIsActiveForLiveChat(isActiveForLiveChat) {
            this.isActiveForLiveChat = isActiveForLiveChat;
        }, get getIsActiveForLiveChat() {
            return toJS(this.isActiveForLiveChat);
        }, setAllAdmins(allAdmins) {
            this.allAdmins = allAdmins;
        }, setLeadBots(leadBots) {
            this.leadBots = leadBots;
        }, get getLeadBots() {
            return toJS(this.leadBots);
        }
    }));

    return (
        <AppStoreContext.Provider value={store}>{children}</AppStoreContext.Provider>
    );
};

export const SESSION_STATUS = {
    LOADING: 'LOADING', UNSET: 'UNSET', ESTABLISHED: 'ESTABLISHED'
};